<template v-if="isLoaded">
  <!-- Header Section -->
  <div class="bg-white shadow sm:rounded-lg mb-6">
    <div class="px-4 py-5 sm:p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <img v-if="companyData.avatar" class="h-16 w-16 rounded-full" :src="companyData.avatar" alt=""/>
          <div class="ml-4">
            <h2 class="text-2xl font-bold text-gray-900">{{ companyData.name }}</h2>
            <p class="text-sm text-gray-500" v-if="companyData.description">{{ companyData.description }}</p>
          </div>
        </div>
        <div>
          <a v-if="companyData.website" :href="`https://${companyData.website}`" target="_blank">
            <button type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
              <LinkIcon class="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true"/>
              Site web
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Chart and Form Section -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
    <!-- Chart Section -->
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg font-medium leading-6 text-gray-900 mb-4">Dépenses mensuelles ({{ fiscalYearName }})</h3>
        <v-chart class="chart" :option="chartOption" autoresize />
      </div>
    </div>

    <!-- Form Section -->
    <div class="bg-white shadow sm:rounded-lg">
        <form action="#" method="POST">
          <div>
            <div class="px-4 py-5 sm:p-6">
              <h3 class="text-lg font-medium leading-6 text-gray-900 mb-4">Informations</h3>

              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-3">
                  <label for="first-name" class="block text-sm font-medium text-gray-700">Fournisseur</label>
                  <input type="text" name="first-name" id="first-name"
                         v-model="companyData.name"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>
                <div class="col-span-6 sm:col-span-3">
                  <label for="name_regex" class="block text-sm font-medium text-gray-700">Fournisseur (regex)</label>
                  <input type="text" name="name_regex" id="name_regex"
                         v-model="companyData.name_regex"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>
                <div class="col-span-6 sm:col-span-3">
                  <label for="description" class="block text-sm font-medium text-gray-700">Description</label>
                  <input v-model="companyData.description"  type="text" name="description" id="description"

                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-6 sm:col-span-2">
                  <label for="sector" class="block text-sm font-medium text-gray-700">Secteur</label>
                  <input type="text" v-model="companyData.sector"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-6 sm:col-span-2">
                  <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                  <input type="text" v-model="companyData.email"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-6 sm:col-span-2">
                  <label for="country" class="block text-sm font-medium text-gray-700">Code Postal</label>
                  <input type="text" v-model="companyData.postalCode"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-6 sm:col-span-2">
                  <label for="country" class="block text-sm font-medium text-gray-700">Ville</label>
                  <input type="text" v-model="companyData.city"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-6 sm:col-span-2">
                  <label for="country" class="block text-sm font-medium text-gray-700">Pays</label>
                  <input type="text" v-model="companyData.country"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

                <div class="col-span-6 sm:col-span-2">
                  <label for="country" class="block text-sm font-medium text-gray-700">Numéro d'enregistrment</label>
                  <input type="text" v-model="companyData.company_registration"
                         class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                </div>

              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button type="button"
                      @click="postNow"
                      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Enregister
              </button>
            </div>
          </div>
        </form>
    </div>
  </div>

  <IssuesLinkPanel v-if="companyData && companyData.id" :type="'company'" :id="companyData.id"
                   :default-title="companyData.name || ''" class="mb-6" />

  <!-- Invoices & Ledger Section -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 items-start">
    <div class="bg-white shadow sm:rounded-lg" v-if="companyData.invoice && companyData.invoice.length > 0">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg font-medium leading-6 text-gray-900 mb-4">Factures associées</h3>
        <div class="overflow-x-auto shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <InvoiceGrid
              :data1="gridData"
              :columns="gridColumns"
              :columns-displayed="gridColumnsDisplayed"
              :page="1"
              :per-page="8"
              :pages="[]"
              :fetch-done="fetchDone"
          />
        </div>
      </div>
    </div>

    <CompanyLedger v-if="companyData && companyData.id" :company="companyData"
                   :fiscal-year-id="userData && userData.fiscal_year ? userData.fiscal_year.id : null"
                   :class="companyData.invoice && companyData.invoice.length > 0 ? '' : 'lg:col-span-2'"
                   @updated="fetchCompanyData" />
  </div>
</template>


<script setup>
import IssuesLinkPanel from '@/components/board/IssuesLinkPanel.vue';
import CompanyLedger from '@/components/company/CompanyLedger.vue';
import {LinkIcon} from '@heroicons/vue/solid'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])
</script>

<script>
import InvoiceGrid from "../../components/invoice/InvoiceGrid.vue";
import axios from "axios";
import {usePost} from "@/composables/fetch";
import moment from 'moment'
import VChart from 'vue-echarts'

export default {
  components: {
    InvoiceGrid,
    VChart
  },
  props: ['id'],
  data: () => ({
    gridColumnsDisplayed: {
      company_name: "Fournisseur",
      status_name: "Status",
      amount: "Montant",
      comment: "Commentaire",
      date: "Date",
      button: "",
    },
    gridColumns: ['id', 'company_name', 'date'],
    gridData: [],
    endpoint: 'company/',
    companyData: {
      invoice: []
    },
    isLoaded: false,
    fetchDone: false,
    userData: null,
    fiscalYearName: '',
    chartOption: {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          rotate: 45
        }
      },
      yAxis: {
        type: 'value',
        name: 'Montant (€)'
      },
      series: [
        {
          name: 'Dépenses',
          type: 'bar',
          data: [],
          itemStyle: {
            color: '#4f46e5'
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c} €'
          }
        }
      ]
    }
  }),
  mounted() {
    this.fetchUserData()
    this.fetchCompanyData()
  },
  methods: {
    async fetchUserData() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      HTTP.get('user')
        .then(response => {
          this.userData = response.data
          this.fiscalYearName = response.data.fiscal_year.name
        })
        .catch(e => {
          console.log(e)
        })
    },
    prepareChartData() {
      if (!this.userData || !this.userData.fiscal_year) return;

      const fiscalYear = this.userData.fiscal_year;
      const startDate = moment(fiscalYear.startDate);
      const endDate = moment(fiscalYear.endDate);

      // Générer la liste des mois dans l'exercice fiscal
      const months = [];
      const monthsData = {};
      let current = startDate.clone();

      while (current.isSameOrBefore(endDate, 'month')) {
        const monthKey = current.format('YYYY-MM');
        const monthLabel = current.format('MMM YYYY');
        months.push(monthLabel);
        monthsData[monthKey] = 0;
        current.add(1, 'month');
      }

      // Agréger les dépenses par mois
      this.companyData.invoice.forEach((invoice) => {
        if (invoice.date) {
          const invoiceDate = moment(invoice.date);
          const monthKey = invoiceDate.format('YYYY-MM');
          if (Object.prototype.hasOwnProperty.call(monthsData, monthKey)) {
            monthsData[monthKey] += parseFloat(invoice.amount) || 0;
          }
        }
      });

      // Convertir en tableau pour echarts
      const data = months.map((monthLabel, index) => {
        const monthKey = moment(fiscalYear.startDate).add(index, 'months').format('YYYY-MM');
        return parseFloat(monthsData[monthKey].toFixed(2));
      });

      // Mettre à jour le graphique
      this.chartOption.xAxis.data = months;
      this.chartOption.series[0].data = data;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-GB').format(date);
    },
    async postNow() {
      const token = await this.$auth.getAccessTokenSilently();
      await usePost(this.endpoint + this.id, this.companyData, token)
      await this.fetchCompanyData();
    },
    async fetchCompanyData() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      HTTP.get(this.endpoint + this.id)
          .then(response => {
            console.log(response.data)
            const {company} = response.data
            this.companyData = company
            this.isLoaded = true;
            const gridData = []
            company.invoice.forEach((value) => {
              // Vérifier si la facture est dans l'exercice fiscal actuel
              let isOutOfCurrentFiscalYear = false;
              if (value['fiscal_year_id'] && this.userData && this.userData.fiscal_year) {
                isOutOfCurrentFiscalYear = value['fiscal_year_id'] !== this.userData.fiscal_year.id;
              }

              gridData.push({
                id: value['id'].substr(0, 10),
                company_name: company ? company['name'] : null,
                company_avatar: company && company['avatar'] != null ? company['avatar'] : 'https://cdn1.iconfinder.com/data/icons/unicons-line-vol-2/24/cloud-question-512.png',
                status_color: value['status'] ? value['status']['color'] : null,
                status_name: value['status'] ? value['status']['name'] : null,
                amount: value['amount'] ? value['amount'] + " €" : null,
                amount_tax: value['amount_tax'] ? value['amount_tax'] + " €" : null,
                comment: value['comment'] ? value['comment'] : null,
                date: value['date'] ? moment(value['date']).format('YYYY-MM-DD') : null,
                created_at: value['created_at'] ? moment(value['created_at']).format('YYYY-MM-DD') : null,
                button: value['id'],
                isOutOfCurrentFiscalYear: isOutOfCurrentFiscalYear,
                dateSort: value['date'] ? moment(value['date']) : null
              })
            })
            // Trier par date, plus récente en haut
            gridData.sort((a, b) => {
              if (!a.dateSort) return 1;
              if (!b.dateSort) return -1;
              return b.dateSort.diff(a.dateSort);
            });
            this.gridData = gridData
            this.fetchDone = true
            this.prepareChartData()
          })

          .catch(e => {
            console.log(e)
          })
    },
  }
}

</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
